import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  return <section className="py-12 border-b border-gray-200" data-id="element-361">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-362">
        Frequently Asked Questions
      </h2>
      <div className="max-w-3xl mx-auto space-y-6" data-id="element-363">
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-364">
          <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-365">
            Q: How quickly can I break the drop dependency?
          </h3>
          <p className="text-gray-700" data-id="element-366">
            A: While individual results vary, most users report needing
            significantly fewer drops within 7-14 days. Many eliminate drops
            entirely within 4-6 weeks of daily use.
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-367">
          <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-368">
            Q: What makes this different from a warm compress?
          </h3>
          <p className="text-gray-700" data-id="element-369">
            A: Warm compresses lose heat in 1-2 minutes and provide no massage
            action. Oculis-3 maintains precise therapeutic temperature (42.5°C)
            for your entire 12-minute session while providing gentle compression
            that helps express blocked glands.
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-370">
          <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-371">
            Q: Is this safe to use with contact lenses?
          </h3>
          <p className="text-gray-700" data-id="element-372">
            A: Remove contact lenses before use. Many users report being able to
            wear their contacts more comfortably throughout the day after
            regular Oculis-3 use.
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-373">
          <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-374">
            Q: Can I use this with my current drops?
          </h3>
          <p className="text-gray-700" data-id="element-375">
            A: Absolutely. Most users find they gradually need fewer drops as
            their natural oil production improves. The goal is to restore your
            natural system, not create a new dependency.
          </p>
        </div>
      </div>
    </section>;
}